import React from 'react'
import { Link } from 'react-router-dom'

import './Breadcrumbs.scss'

/**
 * @import import { Breadcrumbs } from '@/components/forms/Breadcrumbs/Breadcrumbs'
 * @param {object} props
 * @param {object|Array<object>} props.backLinks Prior pages as a single { link, label, dataTestId } object or an array of them
 * @param {React.ReactNode} props.currentLink Label for the current page, rendered as non-link text after the trailing divider
 */
export const Breadcrumbs = ({ backLinks, currentLink }) => {
  const multipleBackLinks = Array.isArray(backLinks)
  const listOfBackLinks = multipleBackLinks ? backLinks : [backLinks]

  return (
    <nav className="breadcrumbs" data-testid="breadcrumbs" aria-label="Breadcrumb">
      {listOfBackLinks.map((backLink) => (
        <React.Fragment key={backLink.label || 'Loading'}>
          <Link to={backLink.link} data-testid={backLink.dataTestId || 'breadcrumb-backlink'}>
            {backLink.label}
          </Link>
          <span className="breadcrumbs-divider" aria-hidden="true">
            /
          </span>
        </React.Fragment>
      ))}
      <span className="breadcrumbs-current" data-testid="breadcrumb-current-link">
        {currentLink}
      </span>
    </nav>
  )
}
